import { render, staticRenderFns } from "./AnText.vue?vue&type=template&id=0c3542a6&scoped=true&"
import script from "./AnText.vue?vue&type=script&lang=js&"
export * from "./AnText.vue?vue&type=script&lang=js&"
import style0 from "./AnText.vue?vue&type=style&index=0&id=0c3542a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3542a6",
  null
  
)

export default component.exports